import merge from 'lodash/merge';
import { getClientMeta } from '@embed/helpers';
import { sendBeacon } from './beacon';
import { sendGet } from './get';
export const sendTracking = (args) => {
    const { url: path, query = {}, data = {}, host } = args;
    const mergedData = merge({}, getClientMeta(), data);
    try {
        return sendBeacon({ path, query, host, data: mergedData });
    }
    catch (err) {
        return sendGet({ path, query, host, data: mergedData });
    }
};
